import { Box, Button, FormControl, InputAdornment, TextField } from "@mui/material";
import { InputLabel } from "components/common/Input";
import { Formik } from "formik";

import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "services/api.service";

type TransactionGroup = {
  airbaseId: string;
  buybackEarningsDebit: string;
  postedAt: Date;
};

export function EarningsDonationTransactionGroupForm() {
  const { uuid, transactionGroupId } = useParams();
  const [today] = useState(() => new Date());
  const navigate = useNavigate();
  const [transactionGroup, setTransactionGroup] = useState<TransactionGroup | null>(null);

  useEffect(() => {
    if (!transactionGroupId) return;
    api.get(`/organizations/${uuid}/transaction_groups/${transactionGroupId}`).then(({ data }) => {
      setTransactionGroup(data);
    });
  }, [transactionGroupId, uuid]);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={
          transactionGroup || {
            airbaseId: "",
            buybackEarningsDebit: "",
            postedAt: today,
          }
        }
        onSubmit={(values) => {
          api
            .post(`/organizations/${uuid}/transaction_groups`, {
              transactionGroup: { type: "EarningsDonation", ...values },
            })
            .then(({ data }) => {
              navigate(`/finance/clients/${uuid}/transaction_groups/EarningsDonation/${data.id}`, {
                replace: true,
              });
            });
        }}
      >
        {({ getFieldProps, handleSubmit }) => (
          <Box
            sx={{
              p: 4,
              mb: 4,
              background: "background.paper",
              borderRadius: 1,
              border: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4 }}>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Debit Amount:</InputLabel>
                <TextField
                  size="small"
                  {...getFieldProps("buybackEarningsDebit")}
                  disabled={!!transactionGroupId}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Airbase ID:</InputLabel>
                <TextField size="small" {...getFieldProps("airbaseId")} disabled={!!transactionGroupId} />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Donation Organization:</InputLabel>
                <TextField size="small" {...getFieldProps("donationOrganization")} disabled={!!transactionGroupId} />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Posted At:</InputLabel>
                <TextField
                  id="name"
                  size="small"
                  type={transactionGroupId ? "" : "date"}
                  {...getFieldProps("postedAt")}
                  disabled={!!transactionGroupId}
                />
              </FormControl>
            </Box>
            {!transactionGroupId && (
              <Box display="flex" justifyContent="flex-end" mt={6}>
                <Button variant="contained" onClick={() => handleSubmit()}>
                  Save
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
